import {gql} from "@apollo/client"
export const GET_PRODUCT_PHOTO_SORT_LIST = gql`
  query GetProductPhotoSortList($tagId: Int!) {
    GetProductPhotoSortList(tagId: $tagId)
  }
`
